import _jsx from "@babel/runtime/helpers/jsx";
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';
import Collapse from '../Collapse/index.js';
import { AccordionContext } from '../Accordion/Accordion';
import { withKeyboardAccessibility } from '../Utilities/AccessibilityUtilities';

/*
*   Assert that event key is among active keys
*/
const isActiveKey = (eventKey, activeEventKeys) => [].concat(activeEventKeys).includes(eventKey);
function AccordionPanel(_ref) {
  let {
    className,
    contentPadding = 4,
    title,
    subTitle,
    eventKey,
    onToggle = () => {},
    children,
    active,
    defaultActive = false,
    iconPlacement = 'after',
    withBorder = false,
    ...rest
  } = _ref;
  const context = useContext(AccordionContext);
  const leftIconPlacement = iconPlacement === 'before';
  useEffect(() => {
    if ((active || defaultActive) && !isActiveKey(eventKey, context.activeEventKeys) && typeof context.handleToggle === 'function') {
      context.handleToggle(eventKey);
    }
    // disable this because we only want to trigger defaultActive on initial load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  delete rest.active;
  delete rest.defaultActive;
  const isActivePanel = isActiveKey(eventKey, context.activeEventKeys);
  const panelClassName = clsx('accordion-panel', {
    'border-neutral-tertiary rounded': withBorder
  }, className);
  const toggleClassName = clsx('display-flex accordion-panel-toggle padding-vertical-4 text-size-400 text-bold', {
    active: isActivePanel,
    'justify-content-between': !!subTitle,
    'padding-left-2 padding-right-4': leftIconPlacement,
    'padding-left-4 padding-right-3': !leftIconPlacement
  });
  const handleClick = () => {
    if (typeof context.handleToggle === 'function') {
      context.handleToggle(eventKey);
    }
    onToggle(eventKey, isActivePanel);
  };
  const additionalTitleClassName = leftIconPlacement ? 'margin-left-auto' : 'margin-right-2';
  const glyphClassName = leftIconPlacement ? 'margin-right-5' : undefined;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "accordionPanel",
    className: panelClassName
  }, rest), /*#__PURE__*/_jsx("div", {
    onClick: handleClick,
    role: "button",
    tabIndex: 0,
    onKeyDown: withKeyboardAccessibility(handleClick),
    className: toggleClassName
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: clsx('margin-right-auto', {
      'margin-left-1': leftIconPlacement
    })
  }, void 0, title), /*#__PURE__*/_jsx("div", {
    className: additionalTitleClassName
  }, void 0, subTitle), /*#__PURE__*/_jsx(Glyphicon, {
    className: clsx('text-size-650', glyphClassName, {
      'margin-right-5': !leftIconPlacement
    }),
    glyph: isActivePanel ? 'menu-up' : 'menu-down',
    style: leftIconPlacement ? {
      order: -1
    } : undefined,
    role: "presentation",
    tabIndex: "-1"
  })), /*#__PURE__*/_jsx(Collapse, {
    in: isActivePanel
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `accordion-panel-content-wrapper padding-horizontal-${contentPadding}`
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "accordion-panel-content"
  }, void 0, children))));
}
export default AccordionPanel;